export default __webpack_public_path__ + "static/media/linkedinIconCircle.f5f5ca93.svg";